<template>
  <!--查看编辑团队-->
  <a-modal
    title="查看"
    style="top: 20px;"
    :width="1200"
    v-model="visible"
    :confirmLoading="confirmLoading"

    :footer="false"
    :maskClosable="false"
  >
    <div class="table-page-search-wrapper">
    <a-form :form="form" layout="inline" >
      <a-row :gutter="24">
        <a-col :span="6" >
          <a-form-item label="团队名称"  >
            <a-input v-model="queryParam.teamName" />
          </a-form-item>
        </a-col>
        <a-col :span="6" >
          <a-form-item label="团员姓名" >
            <a-input v-model="queryParam.memberName" />
          </a-form-item>
        </a-col>
        <a-col :span="6" >
          <a-form-item label="联系方式"  >
            <a-input v-model="queryParam.teamPhone" />
          </a-form-item>
        </a-col>
        <a-col :span="6" >
          <a-form-item label="服务类别" style="margin-left: 28px;" >
            <a-select v-model="queryParam.installType" >
              <a-select-option  v-for="type in restaurantTypes1" :key="type.label">{{type.label}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="6" >
          <a-form-item label="创建时间">
            <a-range-picker
              v-decorator="['datatime1']"
              :showTime="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange1"
              @ok="onOk"
              style="width:100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6" >
            <a-form-item  label="合同文件">
              <a-select style="width: 100%" v-model="queryParam.hasContract">
                <a-select-option value="无">
                  无
                </a-select-option>
                <a-select-option value="有">
                  有
                </a-select-option>
              </a-select>
            </a-form-item>
        </a-col>
        <a-col :span="6" >
          <a-form-item label="标签"  style="margin-left: 28px;">
            <a-select v-model="queryParam.teamLabel">
              <a-select-option  v-for="type in data" :key="type.installLabelName">{{type.installLabelName}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6"  style="margin-top: -10px;">
          <a-row>
            <a-form-item label="近30天投诉率"  >
             <a-col :span="11">
               <a-input  v-model="queryParam.complaintRateBegin" />
             </a-col>
              <a-col :span="2">
                <span style="margin:0 5px">-</span>
              </a-col>
              <a-col :span="11">
                <a-input  v-model="queryParam.complaintRateEnd"  />
              </a-col>
            </a-form-item>
          </a-row>
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin-bottom:20px ">
        <a-col :span="16"></a-col>
        <a-col :span="4" :offset="4">
            <span style="display: flex;justify-content: center;">
              <a-button class="twobtn" type="primary" htmlType="submit"  @click="$refs.table2.refresh(true)">查询</a-button>
              <a-button class="twobtn" style="margin-left: 35px" @click="restDate">清空</a-button>
            </span>
        </a-col>
      </a-row>
    </a-form>
    </div>
    <s-table
      size="default"
      ref="table2"
      rowKey="modelId"
      :loading="loading"
      :columns="columns"
      :scroll="{ x:200 }"
      :data="loadData"
      bordered
    >
      <span slot="installType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>
      </span>
      <span slot="action" slot-scope="text, record">
        <a v-if="teamDetail" @click="handleSee(record.teamId,record)">查看</a>
        <!--<a-divider type="vertical" />-->
        <!--<a v-if="viewEnable" @click="handlSub(record.teamId)">管理子账号</a>-->
        <a-divider v-if="teamDetail" type="vertical" />
        <a v-if="editEnable" @click="handleEdit(record.teamId,record)">编辑</a>
        <a-divider v-if="editEnable" type="vertical" />
        <a v-if="addEnable" @click="newlegAdd(record.teamId)">新增团员</a>
      </span>
    </s-table>
    <sub-account ref="modal" @ok="handleOk"></sub-account>
    <team-details ref="modal2" @ok="handleOk"></team-details>
    <new-league-members ref="modal4" @ok="handleOk"></new-league-members>
  </a-modal>
</template>

<script>
  import { STable } from '@/components'
  import { queryMaster} from '@/api/master/MasterList'
  import { selectALLInstallLabel,} from '@/api/master/MasterList'
  import { teamList } from '@/api/master/TeamManagement'
  import TeamDetails from './TeamDetails.vue'
  import SubAccount from './SubAccount.vue'
  import NewLeagueMembers from './NewLeagueMembers.vue'
  import {getDictMap} from "../../../utils/dict"
  import { checkPermission } from '@/utils/permissions'
    export default {
         name: "ViewEditing",
      components: {
        STable,
        SubAccount,
        TeamDetails,
        NewLeagueMembers
      },
      data(){
          return{
            addEnable: checkPermission('master:teamList:memberList:add'),
            viewEnable:checkPermission('master:teamList:childAccount:view'),
            // seeEnable: checkPermission('master:teamList:see'),
            editEnable: checkPermission('master:teamList:memberList:edit'),
            teamDetail: checkPermission('master:team:detail'),

            form:this.$form.createForm(this),
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
            },
            visible:false,
            confirmLoading: false,
            queryParam:{},
            data:[],
            pagination: false,
            loading: false,
            columns: [
              {
                title: '序号',
                dataIndex: 'rowNum',
                width: '70px',
                align:'center'
              },
              {
                title: '操作',
                dataIndex: 'action',
                width:'20px',
                scopedSlots: { customRender: 'action' },
              },
              {
                title: '团队名称',
                dataIndex: 'teamName',
                align:'center'
              },
              {
                title: '团队人数',
                dataIndex: 'teamNum',
                align:'center'
              },
              {
                title: '标签',
                dataIndex: 'installLabel',
                align:'center'
              },
              {
                title: '得分',
                dataIndex: 'teamScore',
                align:'center'
              },
              {
                title: '分单方式',
                dataIndex: 'openOrder',
                align:'center'
              },
              {
                title: '服务类别',
                dataIndex: 'installType',
                align:'center'
              },
              {
                title: '接单量',
                dataIndex: 'receiveOrder',
                align:'center'
              },
              {
                title: '未销单量',
                dataIndex: 'notSaleOrder',
                align:'center'
              },
              {
                title: '近30天投诉率',
                dataIndex: 'complaintRateRecent',
                align:'center'
              },
              {
                title: '合同文件',
                dataIndex: 'hasContract',
                align:'center'
              },
              {
                title: '合同有效期',
                dataIndex: 'contractDuration',
                align:'center'
              },
              {
                title: '创建日期',
                dataIndex: 'createTime',
                align:'center'
              },
            ],
            masterId:'',
            loadData: parameter => {
              this.queryParam.masterId=this.masterId
              return teamList(Object.assign(parameter, this.queryParam))
            },
          }
      },
      // destroyed () {
      //   this.$nextTick(()=>{
      //     document.body.removeEventListener('keyup', e => {})
      //   })
      // },
      async created(){
          // this.$nextTick(()=>{
          //   document.body.addEventListener('keyup', e => {
          //     if (e.keyCode == 13) {
          //       this.$refs.table2.refresh(true)
          //     }
          //   })
          // })
        this.restaurantTypes1=[]
        this.restaurantOperTypeMap1 = await getDictMap('install_type');
        this.restaurantOperTypeMap1.forEach((value, key) => {
          // console.log(value,key)
          this.restaurantTypes1.push({code: key, label: value})
        })

        this.queryParam.masterId=this.masterId
        // 标签
        selectALLInstallLabel().then(res=>{
          // console.log(res.data)
          this.data = res.data
        })
      },

      methods:{
        restDate(){
          this.queryParam={}
          this.form.resetFields()
          this.$refs.table2.refresh(true)
        },
        onChange1(dates, dateString){
          this.queryParam.startCreateTime=dateString[0]
          this.queryParam.endCreateTime=dateString[1]
        },
        handleSee(id,record){//查看团队

          this.$refs.modal2.add(id,record,0)
        },
        handleEdit(id,record){//编辑团队

          this.$refs.modal2.add(id,record,1)
        },
        handlSub(id){
          console.log(id)
          this.$refs.modal.add(id)
        },
        newlegAdd(id){
          this.$refs.modal4.add(id,2)
        },
        see(val){
          this.queryParam = {}
          this.masterId=val.userId
          this.visible=true
          this.handleOk()
        },
        handleOk () {
          this.$nextTick(() => {
            this.$refs.table2.refresh(true)
          });
        },
      }
    }
</script>

<style scoped>
  .ant-row{
    margin-top: 10px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px;}
</style>